import { useState, useEffect } from 'react';
import axios from 'axios';

const STORE_SEARCH_RADIUS = 50;
const STORES_LIMIT = 5;

const formatStoreWithAvailability = ({ storeList, inventory }) => {
  return storeList.stores.map((store) => {
    const storeAvailability = inventory.find((item) => item.locationNbr === store.storeId);
    return {
      availableQty: storeAvailability?.availableQty || null,
      ...store
    };
  });
};

const useRentalAvailability = ({ rentalCategory, rentalSubCategory, storeId, address }) => {
  const [stores, setStores] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  let storeSearchUrl = '/StoreSearchServices/v2/storesearch/?'
        + `radius=${STORE_SEARCH_RADIUS}`
        + `&pagesize=${STORES_LIMIT}`;
  storeSearchUrl += storeId ? `&storeid=${storeId}` : '';
  storeSearchUrl += address ? `&address=${address}` : '';
  let inventoryUrl = '';

  const fetchData = async (mounted) => {
    setIsError(false);
    setIsLoading(true);
    try {
      const { data: storeResponse, status: storeStatus, statusText: storeStatusText } = await axios(storeSearchUrl);

      if (storeStatus !== 200) {
        throw Error(`statusCode: ${storeStatus}\nstatusText: ${storeStatusText}\nURL: ${storeSearchUrl}`);
      }

      let storeIds = storeResponse.stores.map((store) => store.storeId).join(',');
      inventoryUrl = `/product-information/rental/inventory/${rentalCategory}/${rentalSubCategory}/${storeIds}`;

      const {
        data: inventoryResponse,
        status: inventoryStatus,
        statusText: inventoryStatusText
      } = await axios(inventoryUrl);

      if (inventoryStatus !== 200) {
        // TODO: clean up with better error handling/messaging
        LIFE_CYCLE_EVENT_BUS.trigger('rental-api-sources.error', {
          rentalErrorType: 'RentalFulfillmentComponent',
          rentalMessage: `statusCode: ${inventoryStatus}\nstatusText: ${inventoryStatusText}\nURL: ${inventoryUrl}`,
          rentalEndpoint: {
            storeSearchUrl,
            inventoryUrl
          }
        });
      }

      if (mounted) {
        setStores(formatStoreWithAvailability({
          storeList: storeResponse || [],
          inventory: inventoryResponse || []
        }));
      }
    } catch (error) {
      setIsError(true);
      LIFE_CYCLE_EVENT_BUS.trigger('rental-api-sources.error', {
        rentalErrorType: 'RentalFulfillmentComponent',
        rentalMessage: error?.message,
        rentalEndpoint: {
          storeSearchUrl,
          inventoryUrl
        }
      });
    }

    setIsLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    if (rentalCategory && rentalSubCategory && (storeId !== '8119' || address)) {
      fetchData(mounted);
    }
    return () => { mounted = false; };
  }, [rentalCategory, rentalSubCategory, storeId, address]);
  return { stores, isLoading, isError };
};

export default useRentalAvailability;
